<template>
  <!-- ios不能购买作者列表 -->
  <div>
    <Form
      @submit.native.prevent
      ref="modalForm"
      :model="formData"
      label-position="left"
      class="clearfix"
    >
      <FormItem class="fl" label="作者名称:" :label-width="80">
        <Input v-model="formData.username" placeholder="请输入作者名称" style="width:183px;"></Input>
      </FormItem>
      <Button class="fr ml32" type="primary" @click="handleEdit(0)">添加作者</Button>
      <Button class="fr ml32" type="primary" @click="handleEdit(1)">编辑</Button>

      <p class="fr red" style="line-height:34px;">IOS用户当前{{switchHtml}}购买欢乐豆</p>
      <Button type="primary" class="fl ml24" @click="handleQuery">查询</Button>
      <Button class="fl ml10" @click="handleReset">重置</Button>

      <!-- <FormItem label="是否开启抽奖" class="fr ml32" :label-width="110">
        <RadioGroup v-model.trim="formData.open_lottery_flag">
          <div
            style="width:72px;height:34px;position:absolute;left:0;top:0;z-index:999;"
            @click="handleOpen(formData.open_lottery_flag)"
          ></div>
          <Radio :label="1">是</Radio>
          <Radio :label="0">否</Radio>
        </RadioGroup>
      </FormItem>
      <p class="fr red" style="margin-top:6px;">第一个奖项为正上方0点方向，第二个奖项为顺时针第二个，以此类推。奖项数量必须为6、8、10三种</p>-->
    </Form>

    <Table :loading="tableLoading" class="mt24" :columns="columns" :data="tableData"></Table>
    <!-- 设置奖项弹窗 -->
    <Modal
      v-model="modalVisibile"
      :width="modalWidth"
      :mask-closable="false"
      :title="modalTitle"
      @on-cancel="handleCancel"
    >
      <Form
        @submit.native.prevent
        ref="modalForm"
        :model="modalForm"
        :rules="modalRule"
        inline
        label-position="top"
      >
        <FormItem label="IOS用户购买欢乐豆" v-show="modalType">
          <RadioGroup v-model.trim="modalForm.pay_type">
            <Radio :label="1">能</Radio>
            <Radio :label="0">不能</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem label="作者名称" prop="label" v-show="!modalType">
          <AutoComplete
            class="w200"
            v-model="modalForm.username"
            :data="labelData"
            @on-focus="getLabels"
            placeholder="请输入标签"
            style="width:200px"
          ></AutoComplete>
        </FormItem>
        <!-- <div class="clearfix">
          <div class="w240 fr">
            <FormItem label="是否为大奖" class>
              <RadioGroup v-model.trim="modalForm.big_lottery_flag">
                <Radio :label="1">是</Radio>
                <Radio :label="0">否</Radio>
              </RadioGroup>
            </FormItem>
          </div>
        </div>-->
      </Form>
      <div slot="footer">
        <Button type="text" @click="handleCancel">取消</Button>
        <Button :loading="modalLoading" type="primary" @click="handleModalSubmit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import mixins from "@/mixins/page";
export default {
  name: "setPrize",
  mixins: [mixins],
  data() {
    const validatePhome = (rule, value, callback) => {
      if (isNaN(value - 0)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      labelList: [],
      switchStatus: "",
      formData: {},
       formData1: {},
      labelData: [],
      modalWidth: "",
      modalType: "",
      modalTitle: "",
      //奖项概率是否是100%状态
      prizeRateStatus: false,
      //奖项数量状态
      prizeLengthStatus: false,
      isClick: true,
switchHtml:'',
      prizeList: [],
      //优惠券面值
      cashBox: [],
      //奖项类型
      prizeType: [],
      //奖项数量
      prizeNum: [],
      isAdmin: Number(localStorage.getItem("sa")),
      modalVisibile: false,
      modalLoading: false,
      isShowEnd: true,
      modalForm: {},
      modalForm1: {},
      tableData: [],
      // jsonParam: [],
      modalRule: {
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          },
          { validator: validatePhome, trigger: "blur" }
        ]
      },
      columns: [
        {
          title: "排序号",
          key: "order_no",
           render: (h, params) => {
           
              return h("div", [
                h(
                  "span",
                  params.index+1 
                )
              ]);
            
          }
        },
        {
          title: "作者名称",
          key: "username"
        },
        {
          title: "作者头像",
          key: "lottery_icon",
          render: (h, params) => {
            return h("img", {
              class: {
                table_pic: true
              },
              domProps: {
                src: params.row.poster
              }
            });
          }
        },

        {
          title: "添加时间",
          key: "create_time"
        },

        {
          title: "操作",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  class: {
                    btn_del: true
                  },
                  on: {
                    click: () => this.handleDel(params)
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ]
    };
  },
  watch: {
    label: function(val) {
      this.getLabels();
    }
  },
  computed: {
    label() {
      return this.modalForm.username;
    }
  },
  mounted() {
    this.handleQuery();
    //总开关
    this.getSwitch();
    //获取作者列表
    this.getAuthor();
  },
  methods: {
    getSwitch() {
      this.$api.noBuy_getSwitch({}).then(res => {
        this.switchStatus = res.data.pay_type;
        this.switchHtml=this.switchStatus?'能':'不能'
      });
    },

    //作者列表
    getAuthor() {
      this.$api.noBuy_getAuthorList({}).then(res => {
        this.labelList = res.data;
      });
    },
    //获取搜索作者
    getLabels(value, option) {
      var arr = [];
      if (this.modalForm.username) {
        this.labelList.map(v => {
          if (v.username.indexOf(this.modalForm.username) > -1) {
            arr.push(v.username);
          }
        });
        this.labelData = arr;
      } else {
        this.labelList.map(v => {
          arr.push(v.username);
        });
        this.labelData = arr;
      }
    },
    //点击图标
    handleIcon(type) {
      this.iconType = type;
    },

    // 删除
    handleDel(params) {
      this.$Modal.confirm({
        render: h => {
          return h("div", [
            h(
              "div",
              {
                class: {
                  modal_icon_del: true
                }
              },
              "删除作者"
            ),
            h(
              "div",
              {
                class: {
                  modal_text: true
                }
              },
              "您确定要将该作者从IOS不能购买列表删除吗？"
            )
          ]);
        },
        onOk: () => {
          this.$api
            .noBuy_del({
              author_id: params.row.author_id
            })
            .then(res => {
              if (res.code === 0) {
                this.$Message.success(res.msg);
                this.handleQuery();
              } else {
                this.$Message.error(res.msg);
              }
            });
        }
      });
    },
    handleReset() {
      this.formData = Object.assign({}, this.formData1);
      this.handleQuery();
    },
    handleCancel() {
      this.modalVisibile = false;
      this.modalForm = Object.assign({}, this.modalForm1);
    },
    //添加和编辑
    handleEdit(params) {
      this.modalType = params;
      this.modalVisibile = true;

      //能否购买
      if (params) {
        this.modalWidth = 336;
        this.modalTitle = "IOS能否购买";
        this.modalForm.pay_type = this.switchStatus;
      } else {
        this.modalWidth = 342;
        this.modalVisibile = true;
        this.modalTitle = "添加作者";
      }
    },
    handleModalSubmit() {
      if (this.modalTitle === "添加作者") {
       this.modalLoading = true;
        var id = "";
        this.labelList.map(v => {
          if (v.username === this.modalForm.username) {
            id=v.id
          }
        });

        this.$api.noBuy_setNoBuy({ author_id: id }).then(res => {
          if (res.code == 0) {
            this.handleQuery();
            this.handleCancel();
            this.modalVisibile=false;
          } else {
            this.$Message.error(res.data);
          }
          this.modalLoading = false;
        });
      } else {
        this.modalLoading = true;
        //设置总开关
        this.$api
          .noBuy_setSwitch({ pay_type: this.modalForm.pay_type })
          .then(res => {
            if (res.code == 0) {
              this.modalVisibile = false;
              this.getSwitch();
            } else {
              this.$Message.error(res.data);
            }
            this.modalLoading = false;
          });
      }
    },
    handleQuery() {
      this.page_num = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      this.$api.noBuyList({...this.formData}).then(res => {
        if (res.code === 0) {
          this.tableData = res.data;
        } else {
          this.$Message.error(res.msg);
        }
        this.tableLoading = false;
      });
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .ivu-modal-body {
  padding-bottom: 0;
}
/deep/ .table_pic {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  display: block;
}
/deep/.ivu-input[disabled],
fieldset[disabled] .ivu-input {
  color: #515a6e;
}
.lastInput {
  margin-left: 40px;
}
.lastInput1 {
  margin-left: 128px;
}
/deep/ivu-form-item-content {
  margin-left: 0 !important;
}
.bigLine {
  width: 107%;
  position: relative;
  left: -32px;
  height: 12px;
  background: #f0f3f5;
}
.w160 {
  width: 160px;
}
.disIb {
  display: inline-block;
}
.selectIcon {
  div {
    width: 56px;
    height: 56px;
    border: 1px solid #dce1e6;
    border-radius: 4px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.w90 {
  width: 90px;
}
/deep/ .h48 .ivu-select-selection {
  height: 48px !important;
}
/deep/.h48 .ivu-select-selection .ivu-select-selected-value {
  opacity: 0;
}
.selectedImgBox {
  position: relative;
}
.selectedImg {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  z-index: 999;
}

.shadowIconBox {
  width: 48px;
  height: 48px;
  border: 1px solid #dce1e6;
  border-radius: 4px;
  display: inline-block;
  img {
    width: 100%;
    height: 100%;
  }
}
.shadowIconActive {
  border: 1px solid #1890ff;
  display: inline-block;
}

.ratePlace {
  position: absolute;
  right: 10px;
}
/deep/.ivu-form-inline .ivu-form-item {
  margin-right: 0;
}
/deep/.ivu-auto-complete .ivu-select-dropdown {
  max-height: 240px;
}
</style>
